import React from 'react'
import useBanner from 'components/Banner/hooks/useBanner'
import { getBannerAsset } from 'utils/banner'
import './style/index.scss'
import HtmlParser from 'react-html-parser'
import { useSelector } from 'react-redux'
import { getLoginToken } from 'utils/storageUtils'

const HomeGameBanners = () => {
  const { languageData } = useSelector((state) => state.language)
  const { banners: popularGames, isMobile, selectedLanguageCode } = useBanner({ pageType: 'popular_games' })
  const isLoggedIn = Boolean(getLoginToken())

  const games = popularGames.map((game, index) => ({
    id: index + 1,
    title: game?.[selectedLanguageCode]?.bannerHeading || game?.EN?.bannerHeading || '',
    buttonLink: isLoggedIn ? game?.[selectedLanguageCode]?.bannerloggedInBtn || game?.EN?.bannerloggedInBtn || '' : game?.[selectedLanguageCode]?.bannerloggedOutBtn || game?.EN?.bannerloggedOutBtn || '',
    imageClass: index === 0 ? 'square-game' : 'rectangle-game',
    backgroundImage: getBannerAsset(game, 'background', isMobile)
  }))

  return (
    <div className='home-game-banners-container'>
      <div className='home-game-banners-wrapper'>
        <div className='home-game-banners-item'>
          <div className='home-game-banners-item-content'>
            <div className='home-game-banners-item-content-title'>
              <h2>{languageData?.popularGamesTitle || 'Play the Games Everyone\'s Talking About'}</h2>
            </div>
          </div>
        </div>

        <div className='home-game-banners-grid'>
          {games.map((game) => (
            <div
              key={game.id}
              className={`home-game-banner-card ${game.imageClass}`}
              style={{
                backgroundImage: game.backgroundImage ? `url(${game.backgroundImage})` : 'none'
              }}
            >
              <div className='home-game-banner-card-content-wrapper'>
                <div className='home-game-banner-card-content'>
                  <p className='home-game-banner-card-title'>
                    {game.title}
                  </p>

                  <div className='home-game-banner-card-cta'>
                    <button className='home-game-banner-button'>
                      {game?.buttonLink ? HtmlParser(game?.buttonLink) : `${languageData?.playNow || 'Start Playing'}`}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default HomeGameBanners
